import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { useAdminShortcut } from "@/hooks/useAdminShortcut";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Registrations from "@/pages/admin/Registrations";
import CalendarView from "@/pages/admin/CalendarView";
import Availability from "@/pages/admin/Availability";
import Visitors from "@/pages/admin/Visitors";

function AppRoutes() {
  useAdminShortcut();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="registrations" element={<Registrations />} />
        <Route path="calendar" element={<CalendarView />} />
        <Route path="availability" element={<Availability />} />
        <Route path="visitors" element={<Visitors />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
